// AddressCard — page-level section component for the donor detail's
// mailing-address card.
//
// CHG-1665 / ITER-3774 (Wave 1 / Tier 1 — DonorDetail port).
//
// Consumed via the override-block:section-address-card in
// generated/screens/donor-detail.ts. The override-block's `render:`
// is replaced with `createElement(AddressCard, { donor: r })`.

import type { Donor } from "../../api/types";

export function AddressCard({ donor }: { donor: Donor }) {
  const lines = [
    donor.address_street,
    [donor.address_city, donor.address_state, donor.address_zip]
      .filter(Boolean)
      .join(", "),
    donor.address_country,
  ].filter((s) => s && s.length > 0);

  return (
    <section
      data-testid="address-card"
      style={{
        padding: 16,
        background: "var(--color-surface)",
        border: "1px solid var(--color-border)",
        borderRadius: "var(--radius-md, 8px)",
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      <header
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: "var(--color-text-muted)",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
        }}
      >
        Address
      </header>
      {lines.length === 0 ? (
        <span
          data-testid="address-empty"
          style={{ fontSize: 13, color: "var(--color-text-muted)" }}
        >
          No address on file.
        </span>
      ) : (
        <address
          style={{
            fontStyle: "normal",
            fontSize: 13,
            color: "var(--color-text)",
            lineHeight: 1.6,
          }}
        >
          {lines.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </address>
      )}
    </section>
  );
}
